<template>
  <div>
    <div class="grid ver-padding-40">
      <h1 class="r-margin-30">Добавить предприятие</h1>
    </div>

    <div>
      <form
        @submit.prevent="onSubmit"
        @keypress.enter="pressEnter"
        class="grid"
      >
        <div class="u-16 page-block grid controls-inline">
          <!-- active -->
          <div class="r-margin-20">
            <AppCheckbox v-model="form.active" id="option-active"
              >Активен</AppCheckbox
            >
          </div>
        </div>

        <div class="page-block u-16 grid cross-center between">
          <!-- name -->
          <div class="u-16 u-8-ls r-padding-0 r-padding-10-ls">
            <AppInput
              v-model="form.name"
              label="Название"
              size="medium"
              required
              @blur="validateName(form.name, true)"
              @input="validateName(form.name, false)"
            ></AppInput>
          </div>
          <!-- password -->
          <div
            class="u-16 u-8-ls ver-margin-20 ver-margin-0-ls l-padding-0 l-padding-10-ls"
          >
            <AppInput
              v-model="form.password"
              label="Пароль"
              size="medium"
              required
              @blur="validatePassword(form.password, true)"
              @input="validatePassword(form.password, false)"
            ></AppInput>
          </div>
          <div class="u-16 ver-margin-0 ver-margin-10-ls"></div>
          <!-- human_name -->
          <div class="u-16 u-8-ls r-padding-0 r-padding-10-ls">
            <AppInput
              v-model.trim="form.human_name"
              label="Название 2"
              size="medium"
            ></AppInput>
          </div>
          <!-- currency_code / country_code -->
          <div
            class="u-16 u-8-ls grid ver-margin-20 ver-margin-0-ls l-padding-0 l-padding-10-ls"
          >
            <div class="u-16 u-8-ls r-padding-0 r-padding-10-ls">
              <label>Валюта</label>
              <el-select
                v-model="form.currency_code"
                filterable
                placeholder
                size="large"
              >
                <el-option
                  v-for="item in currencyList"
                  :key="item.currency_id"
                  :label="'[' + item.currency_id + '] ' + item.currency_name_ru"
                  :value="item.currency_id"
                >
                  <span
                    >[{{ item.currency_id }}] {{ item.currency_name_ru }}</span
                  >
                </el-option>
              </el-select>
            </div>
            <div class="u-16 u-0-ls ver-margin-10 ver-margin-0-ls"></div>
            <div class="u-16 u-8-ls l-padding-0 l-padding-10-ls">
              <label>Страна</label>
              <el-select
                v-model="form.country_code"
                filterable
                placeholder
                size="large"
              >
                <el-option
                  v-for="item in countryList"
                  :key="item.iso_num"
                  :label="'[' + item.iso_num + '] ' + item.name_ru"
                  :value="item.iso_num"
                >
                  <img
                    :src="imgSrc(item.iso_num)"
                    alt
                    class="flag-icon r-margin-5"
                  />
                  <span>[{{ item.iso_num }}] {{ item.name_ru }}</span>
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="page-block u-16 grid cross-center between">
          <!-- configuration -->
          <h3 class="u-16">Мультикард</h3>
          <hr class="u-16 ver-margin-15" />
          <div
            v-for="(group, index) in multicardGroups"
            :key="index"
            class="u-16 ver-margin-10"
          >
            <!-- terminals -->
            <div class="u-16 grid cross-center">
              <!-- <div>Группа #{{ index + 1 }}</div> -->
              <label class="u-16">Группа #{{ index + 1 }}</label>
              <el-select
                v-model="form.configuration.multicard.terminals[index]"
                filterable
                clearable
                multiple
                placeholder
                size="large"
                class="u r-margin-20"
              >
                <el-option
                  v-for="(item, index) in terminalList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>

              <AppButton
                size="mini"
                type="red"
                @click.prevent="deleteMulticardGroup(group, index)"
                class="r-margin-20"
                >X</AppButton
              >
            </div>
          </div>
          <AppButton
            size="mini"
            type="green"
            @click.prevent="addMulticardGroup"
            class="r-margin-20"
            >Добавить группу</AppButton
          >
        </div>
        <div class="page-block u-16 grid">
          <AppInput
            class="u-16"
            v-model.trim="form.official_url"
            label="Web-сайт"
            size="medium"
          ></AppInput>
        </div>
        <!-- submit -->
        <div class="u-16 ver-margin-20">
          <AppButton class="r-margin-20" :disabled="disableButton"
            >Добавить</AppButton
          >
          <AppButton type="border" @click.prevent="cancel">Отменить</AppButton>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { apiUrl } from "@/api/apiUrl";
import { mapGetters } from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import { _ } from "vue-underscore";
import errors from "@/localize/errors.js";
Vue.use(VueAxios, axios);

export default {
  name: "AddMerchant",
  data() {
    return {
      loading: false,
      activeName: "multicard",
      form: {
        active: false,
        name: "",
        password: "",
        human_name: "",
        currency_code: "",
        country_code: "",
        configuration: {
          multicard: {
            terminals: []
          }
        },
        official_url: ""
      },
      validateStack: {
        name: false,
        password: false
      },
      is_disabled: true
    };
  },
  methods: {
    onSubmit() {
      let req = { ...this.form };
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      let terminals = req.configuration.multicard.terminals;
      if (terminals.length == 0) req = _.omit(req, "configuration");
      axios
        .post(
          apiUrl + "merchant/create",
          _.omit(req, i => !i),
          config
        )
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.showError("Предприятие успешно добавлено", "success");
            this.cancel();
          } else {
            if (errors.message.hasOwnProperty(data.message))
              this.showError(errors.message[data.message]);
            else this.showError(errors.message["default"]);
            return false;
          }
        })
        .catch(err => {
          console.log(errors);
          if (err.response) this.showError(err.response.data.message);
        });
    },
    cancel() {
      this.$router.push({
        name: "s_Merchants"
      });
    },
    pressEnter(e) {
      e.preventDefault();
    },
    validateName(name, is_shown_message) {
      if (name) {
        let re = /^[a-zA-Z][a-zA-Z0-9-_.]{2,20}$/;
        setTimeout(() => {
          if (!re.test(name)) {
            if (is_shown_message)
              this.showError(
                "Название должно состоять из латинских символов и цифр, без пробелов"
              );
            this.validateStack.name = false;
            return false;
          } else {
            this.validateStack.name = true;
            return true;
          }
        }, 300);
      } else {
        if (is_shown_message) this.showError("Введите название");
        this.validateStack.name = false;
        return false;
      }
    },
    validatePassword(pass, is_shown_message) {
      if (pass) {
        let re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
        setTimeout(() => {
          if (!re.test(pass)) {
            if (is_shown_message)
              this.showError(
                "Пароль должен быть длиной от 8 до 20 знаков, состоять из латинских символов, верхнего и нижнего регистра, цифр и спецсимволов"
              );
            this.validateStack.password = false;
            return false;
          } else {
            this.validateStack.password = true;
            return true;
          }
        }, 300);
      } else {
        if (is_shown_message) this.showError("Введите пароль");
        this.validateStack.password = false;
        return false;
      }
    },
    showError(text, type) {
      type = type ? type : "error";
      this.$message({
        showClose: true,
        message: text,
        type: type,
        duration: 3000
      });
    },
    imgSrc(num) {
      if (num) {
        const url = "https://staticpay.pay2day.kz/static/bo/images/flags/";
        let code = this.countryCodeByNum(num);
        return url + code.toLowerCase() + ".png";
      }
    },
    addMulticardGroup() {
      this.form.configuration.multicard.terminals.push([]);
    },
    deleteMulticardGroup(item, index) {
      let ind = this.form.configuration.multicard.terminals.indexOf(item);
      console.log("TCL: deleteMulticardGroup -> ind", ind, index);
      this.form.configuration.multicard.terminals.splice(index, 1);
    }
  },
  created() {
    if (!this.terminalList || this.terminalList.length == 0)
      this.$store.dispatch("getTerminal");
  },
  computed: {
    ...mapGetters([
      "terminalName",
      "terminalList",
      "processingName",
      "currencyCharacter",
      "currencyList",
      "countryList",
      "countryNameRu",
      "countryCodeByNum"
    ]),
    multicardGroups() {
      let terminals = this.form.configuration.multicard.terminals;
      return terminals;
    },
    disableButton() {
      let count = 0;
      for (let key in this.validateStack) {
        if (this.validateStack[key]) count++;
        else count = 0;
      }
      return count == 0;
    }
  }
};
</script>
